import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getPage, hasError } from '../../../states/page/selectors';
import { getAllMandates, handleViewMandateBack, handleEditMandate } from '../../../states/managePayments/actions';
import { hasApiCallInProgress } from '../../../states/api/selectors';
import { showCancelMandateModal } from '../../../states/cancelPayment/selectors';
import { handleShowCancelModal } from '../../../states/cancelPayment/actions';
import ViewPayee from '../viewPayee';
import { connectWrapper as ImportPayees } from '../importPayees';
import accountPropTypes from '../../../states/accounts/propTypes';
import AddPayeeLayoutContainer from '../../../payees/components/LayoutContainer';
import { getAddPayeeId } from '../../states/selectors';
import { getImportedPayeesList } from '../../../states/importedPayeesList/selectors';
import ManagePayeeList from '../managePayeeList/ManagePayeeList';

const mapState = (state) => ({
	page: getPage(state),
	hasApiCallInProgress: hasApiCallInProgress(state),
	hasError: hasError(state),
	showCancelMandateModal: showCancelMandateModal(state),
	addPayeeId: getAddPayeeId(state),
	importedPayeesList: getImportedPayeesList(state),
});

const mapDispatch = (dispatch) => ({
	getAllMandates: () => dispatch(getAllMandates()),
	handleEdit: ({ id }) => dispatch(handleEditMandate(id)),
	handleShowCancelModal: (mandate) => dispatch(handleShowCancelModal(mandate)),
	handleViewBack: () => dispatch(handleViewMandateBack()),
});
class LayoutContainer extends Component {
	constructor(props) {
		super(props);
		this.renderPage = this.renderPage.bind(this);
	}

	componentDidUpdate() {
		const { hasError, handleRoute } = this.props;
		if (hasError) {
			handleRoute('WEB-ERROR');
		}
	}
	componentWillUnmount() {
		this.props.fetchParentBeneficiary();
	}
	renderPage() {
		const {
			copCheckTriggered,
			page,
			handleRoute,
			gotToMoveMoneyPage,
			handleBack,
			addPayeeId,
			handleFileUploadInReview,
			importedPayeesList,
			isBootStrapInProgress,
			sessionCOPChecks,
		} = this.props;

		switch (page) {
			case 'ManageYourPayee':
				return (
					<ManagePayeeList
						handleRoute={handleRoute}
						handleBack={handleBack}
						isBootStrapInProgress={isBootStrapInProgress}
					/>
				);
			case 'ViewPayeePage':
				return (
					<div className="container container--lg">
						<ViewPayee handleRoute={handleRoute} />
					</div>
				);
			case 'Payee':
				return (
					<div className="container container--lg">
						<AddPayeeLayoutContainer
							copCheckTriggered={copCheckTriggered}
							id={addPayeeId}
							handleRoute={handleRoute}
							gotToMoveMoneyPage={gotToMoveMoneyPage}
							sessionCOPChecks={sessionCOPChecks}
						/>
					</div>
				);
			case 'ImportPayeesPage':
				return (
					<div className="container container--lg">
						<ImportPayees importedPayeesList={importedPayeesList} handleFileUploadInReview={handleFileUploadInReview} />
					</div>
				);
			default:
				return null;
		}
	}
	render() {
		return <div>{this.renderPage()}</div>;
	}
}
LayoutContainer.propTypes = {
	copCheckTriggered: PropTypes.func.isRequired,
	handleRoute: PropTypes.func.isRequired,
	gotToMoveMoneyPage: PropTypes.func.isRequired,
	handleBack: PropTypes.func.isRequired,
	page: PropTypes.string.isRequired,
	hasError: PropTypes.bool,
	addPayeeId: PropTypes.string.isRequired,
	handleFileUploadInReview: PropTypes.func.isRequired,
	fetchParentBeneficiary: PropTypes.func.isRequired,
	importedPayeesList: PropTypes.arrayOf(PropTypes.shape(accountPropTypes).isRequired),
	isBootStrapInProgress: PropTypes.bool,
	sessionCOPChecks: PropTypes.object.isRequired,
};
export default connect(mapState, mapDispatch)(LayoutContainer);
